/*
 * We are not using group names equal to observation shift value
 * because drag and drop library doesn't work well with integers
 */
export default {
  INFREQUENT: "infrequent",
  EXPECTED: "expected",
  FREQUENT: "frequent",
}
